import { faCheck, faChevronDown, faSync, faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material"
import theme from "css/theme/light"
import React, { useEffect, useState } from "react"
import { useStyles } from "./useStyles"
import { useTranslation } from "react-i18next"
const contractErrorMessage = (errorMessages, t) => {
  if (errorMessages) {
    if (
      (errorMessages.invalidRows &&
        errorMessages.invalidRows.length > 0 &&
        errorMessages.nrOfValidRows &&
        errorMessages.nrOfValidRows > 0) ||
      (errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows > 0)
    ) {
      return t(
        "vehicleregistry.not_all_rows_could_be_imported",
        "Not all rows could be imported, review the failed rows below and retry the import or import successful rows by clicking complete import"
      )
    } else if (
      (errorMessages.invalidRows &&
        errorMessages.invalidRows.length < 1 &&
        errorMessages.nrOfValidRows &&
        errorMessages.nrOfValidRows > 0) ||
      (errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows > 0)
    ) {
      return t(
        "vehicleregistry.all_rows_can_be_imported_import_rows",
        "All rows can be imported, import rows by clicking finish import"
      )
    } else {
      return t(
        "vehicleregistry.no_rows_could_be_imported_you_can_review",
        "No rows could be imported, you can review the failed rows below and retry the import"
      )
    }
  }
}
export const CompleteArea = ({ validateResult }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [errorMessages, setErrorMessages] = useState()
  useEffect(() => {
    setErrorMessages(validateResult.data)
  }, [validateResult.data])

  return (
    <Container>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Box bgcolor="background.dark" color="foreground.inverted" borderRadius="8px" padding={10}>
            <Typography variant="h1" align="center" gutterBottom>
              {t("vehicleregistry.almost_done", "Almost done")}
            </Typography>
            <Typography variant="bodySmall" align="center">
              {contractErrorMessage(errorMessages, t)}
            </Typography>
            <Box marginTop={5} />
            <Grid container direction="row" justifyContent="center">
              {errorMessages && (
                <Grid item>
                  <List className={classes.list}>
                    <ListItem>
                      <ListItemIcon>
                        <FontAwesomeIcon color={theme.palette.success["main"]} icon={faCheck} />
                      </ListItemIcon>

                      <ListItemText
                        primary={`${
                          errorMessages.nrOfValidRows && errorMessages.nrOfValidRows
                        } {t("vehicleregistry.agreements_can_be_imported", "agreements can be imported")}`}
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <FontAwesomeIcon color={theme.palette.primary["main"]} icon={faSync} />
                      </ListItemIcon>

                      <ListItemText
                        primary={`${errorMessages.nrOfUpdatedRows && errorMessages.nrOfUpdatedRows} ${t(
                          "vehicleregistry.updated_agreements",
                          "updated agreements"
                        )}`}
                      />
                    </ListItem>
                    <Accordion className={classes.accordion}>
                      <ListItem>
                        <ListItemIcon>
                          <FontAwesomeIcon color={theme.palette.error.main} icon={faTimes} />
                        </ListItemIcon>
                        <AccordionSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} />}>
                          <Typography>
                            {`${
                              errorMessages.invalidRows && errorMessages.invalidRows.length
                            } avtal kan inte importeras`}
                          </Typography>
                        </AccordionSummary>
                      </ListItem>
                      <AccordionDetails>
                        {errorMessages.invalidRows &&
                          errorMessages.invalidRows.map((row, index) => (
                            <Grid
                              key={index}
                              container
                              direction="row"
                              justifyContent="space-between"
                              spacing={2}>
                              <Grid item>
                                <Typography>
                                  {t("global.row_no", "Row no")}: {row.rowNr}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography>{row.errorMessage}</Typography>
                              </Grid>
                            </Grid>
                          ))}
                      </AccordionDetails>
                    </Accordion>
                  </List>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}
